<header>
    <div id="header-logo-wrapper" [routerLink]="menuItems[0].url">
        <div id="header-logo">
            <img [src]="headerLogo" alt="">
        </div>
        <div *ngIf="headerExtraLogo" id="header-logo-extra">
            <img [src]="headerExtraLogo" alt="">
        </div>
    </div>

    <div id="menu-container">
        <div id="menu-button" (click)="toggleMenu()">
            <div id="hamburger"  [style.display]="showSideMenu ? 'none' : 'block'">
                <div class="menu-button-line"></div>
                <div class="menu-button-line"></div>
                <div class="menu-button-line"></div>
            </div>
            <div id="closemenu" [style.display]="showSideMenu ? 'block' : 'none'">
                X
            </div>
        </div>
        <div id="menu-item-container">
            <div *ngFor="let menuItem of menuItems" class="menu-item" [routerLink]="menuItem.url">{{ menuItem.menu }}</div>
            <!--<div class="menu-item" routerLink="home">Home</div>
            <div class="menu-item" routerLink="about">About Us</div>
            <div class="menu-item" routerLink="services">Services</div>
            <div class="menu-item" routerLink="portfolio">Portfolio</div>-->
            <!--<div class="menu-item" routerLink="contact">Contact</div>-->
        </div>
        <!-- BUG:!! side menu stays open when screen is widened -->
        <div id="menu-item-container-side" [style.display]="showSideMenu ? 'block' : 'none'">
            <div *ngFor="let menuItem of menuItems" class="menu-item-side" [routerLink]="menuItem.url" (click)="toggleMenu()">{{ menuItem.menu }}</div>
  <!--   <div class="menu-item-side" routerLink="about" (click)="toggleMenu()">About Us</div>
            <div class="menu-item-side" routerLink="services" (click)="toggleMenu()">Services</div>
            <div class="menu-item-side" routerLink="portfolio" (click)="toggleMenu()">Portfolio</div>-->
            <!--<div class="menu-item-side" routerLink="contact" (click)="toggleMenu()">Contact</div>-->
        </div>
    </div>
</header>
